module.exports = __webpack_public_path__ + "static/media/crabMasala.9714b686.jpeg";